import { Injectable } from '@angular/core';

@Injectable()
export class AuthenticationService {

  private IsUserLoggedIn;
  private LoginUrl: string = '/login';
  private AdminLoginUrl: string = '/notfound';


  constructor() {
    this.IsUserLoggedIn = false;
  }

  SetUserLoggedIn() {
    //this.IsUserLoggedIn = true;

    if (sessionStorage.getItem('IsLogged')) {
      this.IsUserLoggedIn = true;
    } else {
      this.IsUserLoggedIn = false;
    }
  }

  GetUserLoggedIn() {
    return this.IsUserLoggedIn;
  }
  GetLoginUrl(): string {
    return this.LoginUrl;
  }

  GetAdminLoginUrl(): string {
    return this.AdminLoginUrl;
  }

}
